import React from 'react';

class CompanySearch extends React.Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.browseByCity = this.browseByCity.bind(this);
        this.state = { browseByCity: false };      
    }  

    onSubmit()
    {
        this.props.onSubmit();
    }

    browseByCity()
    {
        this.setState({browseByCity: true});
    }

  render() {

    var browseByCity = this.state.browseByCity;
      
    return <div className="container">
        <form className="needs-validation" onSubmit={this.onSubmit}>
            <div className="Search row">
                    <div className="col-md-4">{ !browseByCity && <input className="form-control" type='text' placeholder="Company" name='company' id='company' required></input> }
                    <div class="invalid-feedback">
                    Company name is required.
                    </div>
                </div>
                <div className="col-md-2"><input className="form-control" type='text' placeholder="City" name='city' id='state'></input></div>
                <div className="col-md-2">
                    <select class="custom-select d-block w-100" id="state" required="">
                        <option value="">Choose...</option>
                        <option>Georgia</option>
                    </select>
                </div>
                <div className="col-md-2"><input type="image" src="go-button.png" onClick="form.submit()"/></div>
            </div>
            <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-2"><a href="#" onClick={this.browseByCity}>Browse by city</a></div>
                <div className="col-md-2"></div>
                <div className="col-md-2"></div>
            </div>
        </form>
    </div>
    ;
  }
}


export default CompanySearch;

